var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-list",
        _vm._l(_vm.purchaseOptions, function (option) {
          return _c(
            "v-list-item",
            { key: option.id },
            [
              _c(
                "v-list-item-content",
                { staticClass: "py-1" },
                [
                  _c("SoliPurchaseOption", {
                    attrs: { purchaseOption: option },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("input", option)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }